import { faAddressCard, faBadgePercent, faTvRetro } from "@awesome.me/kit-3777c2145e/icons/classic/regular";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LandingHeader } from "@landing/components/LandingHeader";
import { Grid } from "bm-ui-kit";
import React, { type FC } from "react";
import Skeleton from "react-loading-skeleton";
import { LandingContainer } from "../components/LandingContainer";
import { ContactCard } from "./components/ContactCard";
import { OfficeCard } from "./components/OfficeCard";
import { PartnerOfficeMap } from "./components/PartnerOfficeMap";
import { usePartnerOffices } from "./model/usePartnerOffices";

export const LandingPage: FC = () => {
	const { partnerOffices, isLoading } = usePartnerOffices();

	return (
		<>
			<LandingHeader theme="retail">
				<h1 className="display-1 fw-semibold mb-4">Kapcsolat</h1>
				<Grid
					cols={{
						lg: 3,
					}}
					gap={4}
				>
					<ContactCard
						icon={<FontAwesomeIcon icon={faBadgePercent} size="2xl" className="text-primary" />}
						title="Bankmonitor Kft."
					>
						1037 Budapest, Montevideo utca 16/B.
						<br />
						Adószáma: 23745025-2-41
						<br />
						Cg.: 01-09-976265
						<br />
						<a href="mailto:bankmonitor@bankmonitor.hu">bankmonitor@bankmonitor.hu</a>
					</ContactCard>
					<ContactCard
						icon={<FontAwesomeIcon icon={faTvRetro} size="2xl" className="text-primary" />}
						title="Média Kontakt"
					>
						A média érdeklődéseit interjú, szakmai kommentár, banki adatok, termék adatbázisok,
						összehasonlítások ügyében az alábbi e-mail címen várjuk:
						<br />
						<a href="mailto:sajto@bankmonitor.hu">sajto@bankmonitor.hu</a>
					</ContactCard>
					<ContactCard
						icon={<FontAwesomeIcon icon={faAddressCard} size="2xl" className="text-primary" />}
						title="Rólunk"
					>
						Részletes bemutatkozást a <a href="/rolunk/?link_type=landing-link">Rólunk</a> menüpontban
						talál.
						<br />
						Promóciós, vagy további együttműködési lehetőségekről a{" "}
						<a href="/mediaajanlat/?link_type=landing-link">média ajánlat</a> oldalunkon olvashat.
					</ContactCard>
				</Grid>
			</LandingHeader>
			<LandingContainer size="lg" bgClassName="bg-light">
				<h2>Irodáink</h2>
				<p>
					A Bankmonitor Magyarország legtöbb irodával rendelkező banki szolgáltatásokat közvetítő hálózata.
					Szakértőink országszerte állnak rendelkezésedre.
				</p>
				<PartnerOfficeMap className="rounded-lg" partnerOffices={partnerOffices} />
				<Grid
					cols={{
						md: 2,
						lg: 3,
					}}
					gap={4}
					className="mt-4"
					alignItems={"stretch"}
				>
					{isLoading && (
						<>
							<Skeleton height={320} />
							<Skeleton height={320} />
							<Skeleton height={320} />
						</>
					)}
					{/* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */}
					{!isLoading &&
						partnerOffices.map((office) => (
							<OfficeCard
								key={office.id}
								imgSrc={office.imgSrc}
								imgAlt={office.imgAlt}
								title={office.name}
								address={office.address}
								openingHours={office.openingHours}
								contactInfo={office.contactInfo}
								consultantId={office.consultantId}
							/>
						))}
				</Grid>
			</LandingContainer>
		</>
	);
};
